module.exports = __webpack_public_path__ + "img/amount.7af92d90.svg";